import { Card, CardBody, CardTitle, CardText } from 'reactstrap';

type NoDataCardProps = {
    title: string;
    body: string;
};

export const NoDataCard = ({ title, body }: NoDataCardProps) => {
    return (
        <Card
            style={{
                width: '100%',
                background: 'rgba(1, 174, 180, 0.1)',
                textAlign: 'center',
                padding: 20,
                border: 0,
            }}
        >
            <CardBody style={{ background: 'transparent' }}>
                <CardTitle className='fw-bold'>{title}</CardTitle>
                <CardText dangerouslySetInnerHTML={{ __html: body }}></CardText>
            </CardBody>
        </Card>
    );
};
